export default __webpack_public_path__ + "static/Trazable_Logo_Black-05842e52a64d1e4443408c07d503b3c7.png";